module.exports = __webpack_public_path__ + "img/ss-12.1c9af099.png";